/**
 * @file service-request.constants.ts
 * @module app/modules/service-request/utils/service-request.constants
 * @description Status labels and input limits for the service request portal. The action catalog
 * comes from the server (services/service-request.service.ts).
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.2
 * @version 2.1.2
 */

import { ServiceRequestStatus } from '../types/service-request.types';

/** Order list limit when an action's field does not set maxItems. */
export const MAX_REF_KEYS_PER_REQUEST = 50;
export const MAX_NOTE_LENGTH = 300;
export const MAX_DECLINE_REASON_LENGTH = 300;

export type ServiceRequestStatusTone =
  | 'pending'
  | 'approved'
  | 'declined'
  | 'neutral';

/** Badge label and colour per status. "Completed" reads as Approved: it was approved and ran. */
export const SERVICE_REQUEST_STATUS_UI: Record<
  ServiceRequestStatus,
  { label: string; tone: ServiceRequestStatusTone }
> = {
  [ServiceRequestStatus.Pending]: { label: 'Pending', tone: 'pending' },
  [ServiceRequestStatus.Processing]: {
    label: 'Processing',
    tone: 'pending',
  },
  [ServiceRequestStatus.Completed]: { label: 'Approved', tone: 'approved' },
  [ServiceRequestStatus.Declined]: { label: 'Declined', tone: 'declined' },
  [ServiceRequestStatus.Failed]: { label: 'Failed', tone: 'declined' },
  [ServiceRequestStatus.Withdrawn]: { label: 'Withdrawn', tone: 'neutral' },
};
